import { Block } from "@block";
import { QueueSpacing, StackSpacing } from "@components/spacing";
import { useDesktopMediaQuery } from "@media-query";
import ScreenNameType from "@navigation/nav-screens";
import { StackActions, useNavigation } from "@react-navigation/native";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import BannerAd from "app/shared/components/home/banner-ad/banner-ad";
import FooterHome from "app/shared/components/home/function-gridview/footer-login";
import IconsYellowBanking from "app/shared/components/icons/icon-yellow-banking/IconsYellowBanking";
import TourGuild from "app/shared/components/tour-guild/tour-guild";
import { AppState } from "app/shared/store/root.reducer";
import { globalShowFuture } from "app/shared/util/future";
import { testProps } from "app/shared/util/test-props";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Image, Linking, Pressable, ScrollView, StyleSheet, TouchableOpacity, View } from "react-native";
import { Paragraph, Text, Title, useTheme } from "react-native-paper";
import Animated, { useAnimatedStyle, withSpring } from "react-native-reanimated";
import { useDispatch, useSelector } from "react-redux";
import { CreateResponsiveStyle, DEVICE_SIZES, maxSize } from "rn-responsive-styles";
import { hideTourGuild } from "./reducer/action";
import Modal from "react-modal";
import { spacing } from "app/shared/styles/spacing";
import { setTransferLocalReset } from "../transfer/transfer-local/reducer/actions";
import { setTransfer247Reset } from "../transfer/transfer-247/reducer/actions";
import { setTopUpReset } from "../top-up/reducer/actions";
import { setBillingReset } from "../billings/reducer/actions";
import { pushAppFlyer, pushCleverTapEvent } from "app/shared/util/app-flyer";
import { getContactIdSelector, getStatusListAccountLoginSelector, getUserProfileSelector } from "../account-management/reducer/selectors";
import { fetchCustomerPositionRequest } from "../account-management/reducer/actions";
import { showModal } from "../modal-management/reducer/action";
import images from "app/shared/styles/images";
import { actionLogout } from "../login/reducer/actions";
import auth from "app/shared/services/auth";
import ChangePassword, { createGlobalModalChangePassword, globalModalChangePassword } from "../settings/change-password/change-password";

type PressAbleState = Readonly<{
  pressed: boolean;
  hovered?: boolean;
  focused?: boolean;
}>;

interface ItemGrid {
  icon: string;
  name: string;
  screen?: string;
  id: string | number;
  params?: any;
  eventNameAF?: string;
  eventNameCT?: string;
  eventCTType?: string;
}

interface ItemShortcutLinkFunction {
  name: string;
  icon: string;
  id?: string;
  onPress?: () => void;
}

export const POST_STATUS = {
  LOCK: "L",
  FORCE: "F",
}

const HomeScreen = () => {
  const { dispatch } = useNavigation();
  const { t } = useTranslation();
  const { fonts, colors } = useTheme();
  const isDesktop = useDesktopMediaQuery();
  const dispatchStore = useDispatch();

  const showTourGuildRedux = useSelector((state: AppState) => state.home.showTourGuild);
  const contactId = useSelector(getContactIdSelector);
  const statusListAccountLogin = useSelector(getStatusListAccountLoginSelector);
  const userProfile = useSelector(getUserProfileSelector);
  const [globalModalChangePasswordRef] = React.useState<React.RefObject<any>>(createGlobalModalChangePassword());
  const [isForcePass, setForcePass] = React.useState<boolean>(false);

  const { styles, deviceSize } = useStyles();
  const ICON_SIZE = isDesktop ? 48 : 48;
  const fix_data: Array<ItemGrid> = [
    {
      id: 0,
      icon: "quanlytaikhoan",
      name: t("ACC_QUAN_LY_TAI_KHOAN"),
      screen: ScreenNameType.LIST_ACCOUNT_MANAGEMENT,
    },
    {
      id: 1,
      icon: "chuyentien",
      name: t("TRANFER_CHUYEN_TIEN"),
      screen: ScreenNameType.LIST_TRANSFER,
      eventNameCT: "ct_transfer",
    },
    {
      id: 2,
      icon: "tietkiem",
      name: t("FUNC_TIET_KIEM"),
      screen: ScreenNameType.LIST_FUNCTION_TERM_DEPOSIT,
      eventNameCT: "ct_saving",
    },
    {
      id: 3,
      icon: "qr",
      name: t("COMMON_QR"),
      eventNameAF: "af_scan_qr",
    },
    {
      id: 4,
      icon: "thanhtoan",
      name: t("FUNC_THANH_TOAN"),
      screen: ScreenNameType.LIST_PAYMENTS,
      eventNameCT: "ct_billing",
    },
    {
      id: 5,
      icon: "lienketnhanh",
      name: t("FUNC_TIEN_ICH"),
      screen: ScreenNameType.LIST_UTILITIES,
    },
    {
      id: 6,
      icon: "dichvuthe",
      name: t("CARD_DICH_VU_THE"),
      screen: ScreenNameType.LIST_CARDS,
      params: { resetData: true },
    },
    {
      id: 7,
      icon: "pvone",
      name: t("FUNC_PV_ONE"),
      screen: ScreenNameType.PV_ONE,
      eventNameAF: "af_exchange_pvone_item",
    },
    {
      id: 8,
      icon: "vay",
      name: t("FUNC_MAIN_VAY_TRUC_TUYEN"),
      eventNameAF: "af_create_online_loan",
    },
    {
      id: 9,
      icon: "dautu",
      name: t("FUNC_DAU_TU"),
      eventNameAF: "af_finance_advice",
    },
  ];

  const shortcutLink: Array<ItemShortcutLinkFunction> = [
    {
      icon: "chuyentiennhanhnapas247",
      name: t("TRANFER_CHUYEN_TIEN_NHANH_247"),
      onPress: () => {
        eventPushCleverTap("ct_transfer", "fastfund_napas_247");
        dispatchStore(setTransfer247Reset());
        dispatch(StackActions.push(ScreenNameType.TRANS_247, { resetData: true }));
      },
    },
    {
      icon: "chuyentiennoibo",
      name: t("TRANFER_CHUYEN_TIEN_NOI_BO"),
      onPress: () => {
        eventPushCleverTap("ct_transfer", "the_same_bank");
        dispatchStore(setTransferLocalReset());
        dispatch(StackActions.push(ScreenNameType.TRANS_LOCAL, { resetData: true }));
      },
    },
    {
      icon: "naptiendientu",
      name: t("FUNC_DV_NAP_TIEN"),
      onPress: () => {
        eventPushCleverTap("ct_billing", "top_up");
        dispatchStore(setTopUpReset());
        dispatch(StackActions.push(ScreenNameType.TOP_UP_CREATE, { resetData: true }));
      },
    },
    {
      icon: "thanhtoanhoadontudong",
      name: t("FUNC_DV_THANH_TOAN_HOA_DON"),
      onPress: () => {
        eventPushCleverTap("ct_billing", "billing_payment");
        dispatchStore(setBillingReset());
        dispatch(StackActions.push(ScreenNameType.BILLINGS_CREATE, { resetData: true }));
      },
    },
  ];

  const stylesMemo = React.useMemo(
    () =>
      StyleSheet.create({
        shortLinkIcon: {
          height: spacing.galactic,
          width: spacing.galactic,
        },
        txtUnderline: { color: colors.accent, textDecorationLine: "underline" },
        messageStyle: {
          color: colors.blackText,
          letterSpacing: 0,
          textAlign: "center",
          fontSize: 12,
          ...fonts.regular,
        },
        boldContentStyle: {
          ...fonts.bold,
        },
        link: {
          color: colors.accent,
          textDecorationLine: "underline",
          textDecorationColor: colors.accent,
        },
      }),
    [],
  );

  const onPressFunction = (item: ItemGrid) => {
    if (item.screen && item.screen.length > 0) {
      dispatch(StackActions.push(item.screen, item?.params || {}));
    } else {
      globalShowFuture();
    }
    if (item.eventNameAF && item.eventNameAF.length) {
      const { eventName, params } = handlerParamsAppFlyer(item.eventNameAF);
      pushAppFlyer(eventName, params);
    }
    if (item.eventNameCT && item.eventNameCT.length) {
      eventPushCleverTap(item.eventNameCT);
    }
  };

  const handlerParamsAppFlyer = (eventName: string) => {
    console.log("handlerParamsAppFlyer");
    // af_finance_advice, af_create_online_loan, af_exchange_pvone_item, af_scan_qr
    let param = {};
    if (eventName === "af_finance_advice") {
      param = {
        af_finance_advice: String(true),
      };
    } else if (eventName === "af_create_online_loan") {
      param = {
        af_create_online_loan: String(true),
      };
    } else if (eventName === "af_exchange_pvone_item") {
      param = {
        af_exchange_pvone_item: String(true),
      };
    } else if (eventName === "af_scan_qr") {
      param = {
        af_scan_qr: String(true),
      };
    }
    return {
      eventName: eventName,
      params: {
        af_channel: "ib_rb",
        ...param,
      },
    };
  };

  const eventPushCleverTap = (eventName: string, action?: string) => {
    const { eventNameCT, paramsCT } = handlerParamsCleverTap(eventName, action);
    pushCleverTapEvent(eventNameCT, paramsCT);
  };

  const handlerParamsCleverTap = (eventName: string, action?: string) => {
    console.log("handlerParamsCleverTap");
    let param = {};
    if (eventName === "ct_transfer") {
      param = {
        ct_transfer_type: action || "",
      };
    } else if (eventName === "ct_billing") {
      param = {
        ct_billing_type: action || "",
      };
    } else if (eventName === "ct_saving") {
      param = {
        ct_cta: action || "",
      };
    }
    return {
      eventNameCT: eventName,
      paramsCT: {
        ct_cccd_ID: contactId,
        ct_device_ID: "",
        ct_channel: "ib_rb",
        ...param,
      },
    };
  };

  const handlerAcceptDialog = (status: string) => {
    if (status === POST_STATUS.LOCK || status === POST_STATUS.FORCE) {
      auth.logout();
      dispatchStore(actionLogout());
    }
  };

  const onClickLinkUpdateApp = (type: string) => {
    if (type === "IOS") Linking.openURL("https://apps.apple.com/vn/app/pvconnect/id6467857410");
    else Linking.openURL("https://play.google.com/store/apps/details?id=com.pvcombank.retail");
  };

  const content = (
    <Block center>
      <Paragraph style={stylesMemo.messageStyle}>{t("COMMON_THONG_BAO_FORCE_PVCONNECT_APP")}</Paragraph>
      <StackSpacing size="small" />
      <Image source={images.pv_connect_update} style={{ width: 150, height: 150 }} />
      <StackSpacing size="small" />
      <Paragraph style={stylesMemo.messageStyle}>
        <Paragraph style={[stylesMemo.messageStyle, stylesMemo.boldContentStyle]}>{t("COMMON_QUET_QR")} </Paragraph>
        {t("COMMON_QUET_QR_UPDATE")}
      </Paragraph>
      <StackSpacing size="small" />
      <Block row spaced>
        <TouchableOpacity onPress={() => onClickLinkUpdateApp("IOS")}>
          <Image source={images.app_store_update} style={{ width: 100, height: 30 }} />
        </TouchableOpacity>
        <QueueSpacing size="large" />
        <TouchableOpacity onPress={() => onClickLinkUpdateApp("ANDROID")}>
          <Image source={images.play_store_update} style={{ width: 100, height: 30 }} />
        </TouchableOpacity>
      </Block>
    </Block>
  );

  const showDialogUpdatePVConnectApp = (status: string) => {
    let title: string = t("COMMON_THONG_BAO_LOCK_PVCONNECT_APP_TITLE");
    let dialogMessage: string = t("COMMON_THONG_BAO_LOCK_PVCONNECT_APP");
    let contentModal = undefined;
    if (status === POST_STATUS.FORCE) {
      title = t("COMMON_THONG_BAO_FORCE_PVCONNECT_APP_TITLE");
      contentModal = content;
    }
    dispatchStore(
      showModal({
        modalType: "updateAppModal",
        modalProps: {
          open: true,
          title: title,
          message: dialogMessage,
          content: contentModal,
          titleBtnAccept: t("COMMON_TOI_DA_HIEU").toUpperCase(),
          titleBtnCancel: undefined,
          acceptModal: () => handlerAcceptDialog(status),
        },
      }),
    );
  };

  const checkUserUpdatePVConnect = () => {
    if (userProfile?.POSTSTATUS === POST_STATUS.LOCK || userProfile?.POSTSTATUS === POST_STATUS.FORCE) {
      showDialogUpdatePVConnectApp(userProfile?.POSTSTATUS);
      //L: User đã chuyển qua dùng PVConnect => khoá sử dụng IB
      //F: Thông báo KH chuyển sang PVConnect (Bắt buộc)
    } else {
      dispatchStore(fetchCustomerPositionRequest());
    }
  };

  React.useEffect(() => {
    if (statusListAccountLogin === "ok") {
      checkUserUpdatePVConnect();
    }
  }, [statusListAccountLogin]);

  const showModalForeChangePassword = () => {
    globalModalChangePassword.show(globalModalChangePasswordRef);
  };

  React.useEffect(() => {
    // Check Force change password
    if (userProfile) {
      console.log("userProfile: ", userProfile);
      if (userProfile.PASSWORDCHANGED === "X" || userProfile.PASSWORDCHANGED === "S") {
        setForcePass(true);
      } else {
        setForcePass(false);
      }
    }
  }, [userProfile]);

  React.useEffect(() => {
    if (isForcePass === true) {
      showModalForeChangePassword();
    }
  },[isForcePass]);

  const ShortcutLinkFunction = (
    <View style={styles("shorcutWrapContainer")}>
      {shortcutLink.map((_item, _index) => {
        return (
          <Pressable key={_index} style={styles("shorcutItemContainer")} onPress={_item.onPress} {...testProps(_item.icon)}>
            {({ hovered }: PressAbleState) => {
              // eslint-disable-next-line react-hooks/rules-of-hooks
              const captionStyle = useAnimatedStyle(() => {
                return {
                  overflow: "visible",
                  transform: [
                    {
                      scale: hovered ? withSpring(1.1) : withSpring(1),
                    },
                  ],
                };
              });
              return (
                <Animated.View style={captionStyle}>
                  <Block center>
                    <Block middle style={stylesMemo.shortLinkIcon} br={12} bg={colors.backgroundForm} center>
                      <IconsYellowBanking name={_item.icon} size={ICON_SIZE} />
                    </Block>
                  </Block>
                  <StackSpacing size="micro" />
                  <Text numberOfLines={3} style={styles("shorcutText")}>
                    {_item.name}
                  </Text>
                </Animated.View>
              );
            }}
          </Pressable>
        );
      })}
    </View>
  );

  const HeaderFunction = (
    <>
      <HeaderNav />
      <BannerAd />
      <Block>
        {ShortcutLinkFunction}
        <StackSpacing size="micro" />
        <Title style={styles("titleHeader")}>{t("FUNC_DICH_VU")}</Title>
        <StackSpacing size="micro" />
      </Block>
    </>
  );

  const FooterView = (
    <View style={styles("footerContainer")}>
      <FooterHome />
    </View>
  );

  const renderTourGuild = (
    <Modal
      ariaHideApp={false}
      style={{
        overlay: {
          backgroundColor: colors.backdrop,
        },
        content: {
          border: "none",
          background: "transparent",
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          marginRight: "-50%",
          transform: "translate(-50%, -50%)",
        },
      }}
      isOpen={isForcePass === true ? false : showTourGuildRedux}
      onRequestClose={() => dispatchStore(hideTourGuild())}
      contentLabel="Example Modal">
      <TourGuild onHideTourGuild={() => dispatchStore(hideTourGuild())} />
    </Modal>
  );

  const getPaddingTop = (index: number) => {
    let padding: number = spacing.none;
    switch (deviceSize) {
      case DEVICE_SIZES.EXTRA_LARGE_DEVICE:
        if (index > 4) padding = spacing.medium;
        break;
      case DEVICE_SIZES.LARGE_DEVICE:
      case DEVICE_SIZES.MEDIUM_DEVICE:
      case DEVICE_SIZES.SMALL_DEVICE:
        if (index > 3) padding = spacing.medium;
        break;
      case DEVICE_SIZES.EXTRA_SMALL_DEVICE:
        if (index > 2) padding = spacing.medium;
        break;
      default:
        padding = spacing.none;
        break;
    }
    return padding;
  };

  const FunctionGrid = (
    <View style={styles("functionWrapContainer")}>
      {fix_data.map((_item, _index) => (
        <Pressable key={_item.id} style={styles("functionItemContainer")} onPress={() => onPressFunction(_item)}>
          {({ hovered }: PressAbleState) => {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const captionStyle = useAnimatedStyle(() => {
              return {
                overflow: "visible",
                transform: [
                  {
                    scale: hovered ? withSpring(1.1) : withSpring(1),
                  },
                ],
              };
            });
            return (
              <Animated.View style={[captionStyle, { paddingTop: getPaddingTop(_index) }]}>
                <Block center>
                  <IconsYellowBanking name={_item.icon} size={ICON_SIZE} />
                </Block>
                <StackSpacing size="micro" />
                <Text numberOfLines={3} style={styles("functionText")}>
                  {_item.name}
                </Text>
                <StackSpacing size="medium" />
              </Animated.View>
            );
          }}
        </Pressable>
      ))}
    </View>
  );

  return (
    <>
      <ScrollView contentContainerStyle={styles("containerScrollView")} {...testProps("home")}>
        {HeaderFunction}
        {FunctionGrid}
        {FooterView}
        <ChangePassword ref={globalModalChangePasswordRef}/>
      </ScrollView>
      {/* {renderTourGuild} */}
    </>
  );
};

const useStyles = CreateResponsiveStyle(
  {
    containerScrollView: {
      flexGrow: 1,
    },
    text: {
      fontSize: 30,
      color: "white",
    },
    titleHeader: {
      marginLeft: 16,
      fontFamily: "Montserrat-Medium",
      fontWeight: "500",
    },
    shorcutWrapContainer: {
      flexDirection: "row",
      flexWrap: "nowrap",
      // marginHorizontal: "20%",
    },
    shorcutItemContainer: {
      flex: 1,
      maxWidth: "25%",
    },
    shorcutText: {
      maxWidth: "90%",
      alignSelf: "center",
      fontFamily: "Montserrat-Medium",
      fontWeight: "500",
      textAlign: "center",
      fontSize: 13,
    },
    functionText: {
      maxWidth: "90%",
      alignSelf: "center",
      fontFamily: "Montserrat-Medium",
      fontWeight: "500",
      textAlign: "center",
      fontSize: 13,
    },
    functionWrapContainer: {
      flexDirection: "row",
      flexWrap: "wrap",
      marginBottom: 60,
    },
    functionItemContainer: {
      flex: 1,
    },
    modalStyle: { alignSelf: "center" },
    footerContainer: {
      zIndex: 0,
      bottom: 0,
      right: 0,
      left: 0,
      position: "absolute",
      flex: 1,
      justifyContent: "flex-end",
    },
    regularText: {
      fontSize: 13,
    },
  },
  {
    [DEVICE_SIZES.EXTRA_LARGE_DEVICE]: {
      shorcutWrapContainer: {
        marginHorizontal: "20%",
      },
      titleHeader: {
        marginLeft: "10%",
      },
      functionItemContainer: {
        flex: 1,
        minWidth: "20%",
        maxWidth: "20%",
      },
      functionWrapContainer: {
        marginHorizontal: "15%",
      },
    },
    [maxSize(DEVICE_SIZES.LARGE_DEVICE)]: {
      functionItemContainer: {
        minWidth: "25%",
        maxWidth: "25%",
      },
      functionWrapContainer: {
        marginHorizontal: "5%",
      },
      shorcutWrapContainer: {
        paddingHorizontal: "5%",
      },
    },
    [DEVICE_SIZES.EXTRA_SMALL_DEVICE]: {
      shorcutWrapContainer: {
        paddingHorizontal: 0,
      },
      functionItemContainer: {
        minWidth: "33.33%",
        maxWidth: "33.33%",
      },
      titleHeader: {
        marginLeft: 16,
      },
      functionWrapContainer: {
        marginHorizontal: 16,
      },
      regularText: {
        fontSize: 11,
      },
      shorcutText: {
        fontSize: 11,
      },
      functionText: {
        fontSize: 11,
      },
    },
  },
);

export default HomeScreen;
